const SPANISH_MONTHS = {
  JANUARY: 'enero',
  FEBRUARY: 'febrero',
  MARCH: 'marzo',
  APRIL: 'abril',
  MAY: 'mayo',
  JUNE: 'junio',
  JULY: 'julio',
  AUGUST: 'agosto',
  SEPTEMBER: 'septiembre',
  OCTOBER: 'octubre',
  NOVEMBER: 'noviembre',
  DECEMBER: 'diciembre'
};

const addBusinessDays = (date, days) => {
  const currentDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  let addedDays = 0;
  while (addedDays < days) {
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
    if (currentDate.getUTCDay() !== 0 && currentDate.getUTCDay() !== 6) {
      addedDays++;
    }
  }
  return currentDate;
};

const addCalendarDays = (date, days) => {
  const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  newDate.setUTCDate(newDate.getUTCDate() + days);
  return newDate;
};

const getEndOfMonth = (date) => {
  const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1));
  newDate.setUTCMonth(newDate.getUTCMonth() + 1);
  newDate.setUTCDate(0);
  return newDate;
};

const getEndOfQuarter = (date) => {
  const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1));
  const month = newDate.getUTCMonth();
  const quarter = Math.floor(month / 3);
  newDate.setUTCMonth((quarter + 1) * 3);
  newDate.setUTCDate(0);
  return newDate;
};

const getSpanishMonth = (date) => {
  return Object.values(SPANISH_MONTHS)[date.getUTCMonth()];
};

const findNoticePeriod = (amount, periods) => {
  return periods.find(period =>
    period.condition === 'lt' ? amount < period.amount :
      period.condition === 'gte' ? amount >= period.amount : false
  );
};

const generateFilAlert = (operation, amount, date, tradingRules) => {
  if (!tradingRules) return '';

  const navDateStr = generateFilNavDate(operation, amount, date, tradingRules);
  if (!navDateStr) return '';

  // The string is already in UTC 'YYYY-MM-DD' format.
  // To get the month name correctly without timezone issues, we create a UTC date.
  const navDate = new Date(navDateStr + 'T00:00:00Z');

  return `Se aplicará el valor liquidativo de ${getSpanishMonth(navDate)}.`;
};

const generateFilNavDate = (operation, amount, date, tradingRules) => {
  if (!tradingRules) return null;

  let navDate = null;

  if (operation === 'SUSCRIPCION' || operation === 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA' || operation === 'SOLICITUD_TRASPASO_INTERNO') {
    const noticeDate = tradingRules.subscription.notice_type === 'business'
      ? addBusinessDays(date, tradingRules.subscription.notice_days)
      : addCalendarDays(date, tradingRules.subscription.notice_days);
    const currentMonthEnd = getEndOfMonth(date);
    navDate = noticeDate > currentMonthEnd
      ? getEndOfMonth(new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 1)))
      : currentMonthEnd;

  } else if (operation === 'REEMBOLSO') {
    const noticePeriod = findNoticePeriod(amount, tradingRules.redemption.notice_periods);
    if (!noticePeriod) return null;

    const noticeDate = noticePeriod.type === 'business'
      ? addBusinessDays(date, noticePeriod.days)
      : addCalendarDays(date, noticePeriod.days);

    if (tradingRules.redemption.frequency === 'quarterly') {
      const currentQuarterEnd = getEndOfQuarter(date);
      navDate = noticeDate > currentQuarterEnd
        ? getEndOfQuarter(new Date(Date.UTC(date.getFullYear(), date.getMonth() + 3, 1)))
        : currentQuarterEnd;
    } else {
      const currentMonthEnd = getEndOfMonth(date);
      navDate = noticeDate > currentMonthEnd
        ? getEndOfMonth(new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 1)))
        : currentMonthEnd;
    }
  }

  if (!navDate) return null;

  return navDate.toISOString().slice(0, 10);
};

export { generateFilAlert, generateFilNavDate };
